<template>
  <div class="relative w-full py-16 md:mb-8">
    <div class="absolute inset-0 hidden md:block dark:bg-gradient-to-br dark:from-gray-900 dark:to-gray-800 bg-gradient-to-br from-gray-100 to-gray-200 clip-diagonal"></div>

    <div class="relative flex flex-col md:flex-row items-center justify-center gap-2 max-w-6xl mx-auto px-6">
      <div class="text-center md:text-left flex-1">
        <h1 class="text-gray-900 dark:text-gray-100 text-5xl md:text-7xl font-bold font-Niramit">
          {{ name }}
        </h1>
        <p class="text-gray-700 dark:text-gray-300 text-2xl md:text-4xl mt-2">
          {{ title }}
        </p>
      </div>

      <img
          src="../assets/profile.jpeg"
          alt="Profile Picture"
          class="rounded-full mt-8 md:mt-0 w-64 h-64 md:w-96 md:h-96 object-cover shadow-lg"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileSection',
  data() {
    return {
      profilePicture: '../assets/profile.png',
      name: 'Muhammad Hamza Naeem',
      title: 'Full Stack Software Engineer',
    };
  },
};
</script>

<style scoped>
/* Diagonal background effect */
.clip-diagonal {
  clip-path: polygon(0 0, 100% 0, 55% 100%, 0 100%);
}
</style>
